module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "vux-datetime weui-cell",
    class: {
      'weui-cell_access': !_vm.readonly
    },
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._t("default", [_c('div', [_vm._t("title", [_c('p', {
    style: ({
      width: _vm.$parent.labelWidth,
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft vux-cell-primary vux-datetime-value",
    style: ({
      textAlign: _vm.valueTextAlign
    })
  }, [_vm._v("\n      " + _vm._s(_vm._value) + "\n      "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.valid),
      expression: "!valid"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn",
      "title": _vm.firstError
    }
  })], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03eb2a41"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/datetime/index.vue
// module id = 460
// module chunks = 4